export default __webpack_public_path__ + "static/media/profile_web.184bb385.png";